import { makeStyles } from '@material-ui/core';
import Arrow from './images/dropDown.svg'
export const styles = makeStyles(theme => ({
    contentContainer: {
        maxWidth: '100%',
        height: '100%',
        margin: 'auto',
        padding: 0,
        textAlign: 'center',
        paddingTop: 30,
        [theme.breakpoints.down('sm')]: {
            padding: '0 7px',
        },
    },
    mobileHeader: {
        position: 'sticky',
        top: 95,
        width: '100%',
        backgroundColor: 'white',
        zIndex: 1,
    },
    mobileMarketFilter: {
        width: "100%",
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        padding: '18px 0',
        [theme.breakpoints.down('600')]: {
            padding: '10px 0',
        },
    },
    mobileSportsBook: {
        marginLeft: '10%',
        '& img': {
            display: 'block',
            maxWidth: '104px',
            height: '40px',
            width: 'auto',
            objectFit: 'contain',
        },
    },
    justifyStart: {
        justifyContent: 'flex-start !important',
    },
    fullGameCol: {
        fontSize: 18,
        "& p": {
            marginBottom: 8,
            fontFamily: 'proxima-nova',
        }
    },
    mobileHeaderContainer: {
        borderBottom: '1px solid #D1CFD7',
        borderTop: '1px solid #D1CFD7',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: 10,
        paddingBottom: 10,
    },
    backBtnContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.up('600')]: {
            display: 'none',
        },
    },
    mobileDropdownContainer: {
        flex: 1,
        height: 40,
        overflow: 'hidden',
        marginLeft: 5
    },
    dropdown: {
        width: "100%",
        padding: 10,
        fontSize: 16,
        lineHeight: 1,
        border: "1px solid #D1CFD7",
        borderRadius: 8,
        height: 40,
        background: `url(${Arrow}) no-repeat right #fff`,
        '-webkit-appearance': 'none',
        backgroundPositionX: "95%",
        '&::before': {
            content: 'none',
        },
        '&::after': {
            content: 'none',
        },
        '& svg': {
            display: 'none',
        },
        '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 10,
        }
    },
    graphIcon: {
        marginLeft: 15,
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    graphActive: {
        backgroundColor: '#074589',
        borderRadius: 5
    },
    imageBtn: {
        padding: 1,
    },
    browserView: {
        display: 'flex',
        width: '100%',
    },
    firstPart: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        width: '100%',
    },
    secondPart: {
        display: 'flex',
        flex: '2',
        marginLeft: 40,
        overflowX: 'hidden',
    },
    browserHeaderContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '25px 0',
    },
    browserDropdownContainer: {
        width: "100%",
        height: 40,
        overflow: 'hidden',
    },
    marketEmptyDiv: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        marginTop: 15,
        paddingBottom: 15,
        borderBottom: '1px solid #E5E5E5',
    },
}));

